import script from "./WidgetSlideover.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetSlideover.vue?vue&type=script&setup=true&lang=js"

import "./WidgetSlideover.vue?vue&type=style&index=0&id=42904410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42904410"]])

export default __exports__